import axios from "axios";
import { baseUrl } from "../../../utils/constants/constants";
import { RegisterPayload } from "../types/types";

export type EstadoOption = {
	id: string;
	uf: string;
};

const parseJsonPayload = (data: unknown): unknown => {
	let current = data;
	for (let i = 0; i < 2; i++) {
		if (typeof current !== 'string') break;
		try {
			current = JSON.parse(current);
		} catch {
			break;
		}
	}
	return current;
};

export const fetchCep = async (cep: string) => {
    try {
        const response = await axios.get(`https://brasilapi.com.br/api/cep/v1/${cep}`);
        return response.data;
    } catch (error : any) {
        return error.response.data;
    }
};

export const fetchEstados = async (): Promise<EstadoOption[]> => {
	const response = await axios.get(`${baseUrl}EstadoCidade`);
	const parsed = parseJsonPayload(response.data);
	if (!Array.isArray(parsed)) return [];

	return parsed
		.map((row: Record<string, unknown>) => ({
			id: String(row.name ?? row.Name ?? ''),
			uf: String(row.value ?? row.Value ?? '').trim().toUpperCase(),
		}))
		.filter((estado) => estado.id && estado.uf);
};

export const fetchCidades = async (estadoId: string): Promise<string[]> => {
	const response = await axios.get(`${baseUrl}EstadoCidade/${estadoId}`);
	const parsed = parseJsonPayload(response.data);
	if (!Array.isArray(parsed)) return [];

	return parsed
		.map((row: Record<string, unknown>) =>
			String(row.valor ?? row.Valor ?? row.value ?? row.Value ?? '').trim()
		)
		.filter(Boolean);
};

export const formatApiMessage = (value: unknown, fallback: string): string => {
	if (typeof value === 'string' && value.trim()) return value.trim();
	if (value && typeof value === 'object') {
		const obj = value as Record<string, unknown>;
		const fromObject = [obj.title, obj.detail, obj.message, obj.Message]
			.find((item) => typeof item === 'string' && item.trim());
		if (typeof fromObject === 'string') return fromObject.trim();
	}
	return fallback;
};

export const registerUser = async (user: RegisterPayload) => {
    const url = `${baseUrl}Revendas/CreateRevendaExterno`;
    try {
        const response = await axios.post(url, user);
        return formatApiMessage(response.data, 'Revenda cadastrada com sucesso!');
    } catch (error : any) {
        return formatApiMessage(
			error?.response?.data,
			'Erro ao realizar cadastro. Tente novamente.'
		);
    }
};
